import {
  Modal, Button, Steps, Flex
} from "antd";
import { useTranslation } from "react-i18next";
import classes from "./onboardingModal.module.css";
import useOnboardingModal from "./useOnboardingModal";

interface OnboardingModalProps { isOpen: boolean, handleToggle: () => void }

const OnboardingModal = ({ isOpen, handleToggle } : OnboardingModalProps) => {
  const { t } = useTranslation();
  const {
    loading,
    current,
    items,
    steps,
    prevButtonText,
    nextButtonText,
    handlePrevClick,
    handleNextClick
  } = useOnboardingModal({ handleToggle });

  return (
    <Modal
      open={isOpen}
      title={t("dashboardPage.onboarding.modalTitle")}
      width={600}
      onCancel={() => handleToggle()}
      centered
      footer={null}
      className={classes.root}
      forceRender
    >
      <Steps size="small" current={current} items={items} style={{ marginTop: 16 }}/>
      <div>{steps[current].content}</div>
      <Flex justify="end" gap={8} style={{ marginTop: 24 }}>
        <Button onClick={handlePrevClick} disabled={loading} loading={loading}>
          {prevButtonText()}
        </Button>
        <Button type="primary" onClick={handleNextClick} disabled={loading} loading={loading}>
          {nextButtonText()}
        </Button>
      </Flex>
    </Modal>
  );
};

export default OnboardingModal;
